import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import * as shapes from '../shapes';
import Date from '../../../../common/date';
import PromoValue from './PromoValue';
import Money from '../../../../common/money';
import Checkbox from '../../../../common/Checkbox';

const Item = ({ promoCode, baseUrl, disabled }) => (
  <Link className="c-table-card__row" to={disabled ? '' : `${baseUrl}/${promoCode.id}/edit`}>
    <div className="c-table-card__cell">
      <code>
        {promoCode.code}
      </code>
    </div>
    <div className="c-table-card__cell">
      <PromoValue promoCode={promoCode} />
    </div>
    <div className="c-table-card__cell">
      <Checkbox checked={promoCode.firstAppointmentOnly} readOnly />
    </div>
    <div className="c-table-card__cell">
      <Checkbox checked={promoCode.oneTime} readOnly />
    </div>
    <div className="c-table-card__cell">
      <Date>
        {promoCode.expirationDate}
      </Date>
    </div>
    <div className="c-table-card__cell">
      {promoCode.redeemCount}
    </div>
    <div className="c-table-card__cell">
      <Money>{promoCode.totalRedeemedAmount}</Money>
    </div>
  </Link>
);

Item.propTypes = {
  promoCode: shapes.promoCode.isRequired,
  baseUrl: shapes.url.isRequired,
  disabled: PropTypes.bool,
};

Item.defaultProps = {
  disabled: false,
};

export default Item;
